<template>
  <div>
    <div class="row menubar">
      <input type="text" ref="search" placeholder="Zoeken" @keyup="updateSearch" class="searchbar">
      <button @click="sendAll=true" style="float:right;">
        <awesomeIcon icon="paper-plane"/> Verstuur geselecteerd
      </button>
    </div>

    <modalWindow v-if="read !== null" @close="read=null">
      <div class="titlebar">Bericht</div>
      <div class="inset">
        Gebruiker: {{read.email}} ({{read.client}})<br>
        <br>
        <b>De alertwaarde van portefeuille {{read.port}} is bereikt</b><br>
        <br>
        De haalbaarheid van uw doel {{read.name}} is onder de door u opgegeven Alertwaarde van
        {{read.alert}} gekomen.<br>
        <br>
        <template v-if="read.name">Uw doel: {{read.name}}<br></template>
        Uw portefeuille: {{read.port}}<br>
        Uw alertwaarde: {{this.formatPrice(Number(read.alert), false, 1)}}%<br>
        Uw huidige haalbaarheid: {{this.formatPrice(Number(read.score), false, 1)}}%<br>
        <br>
        U kunt uw haalbaarheid weer naar uw oorspronkelijke waarde verhogen of u kunt aangeven dat
        u tevreden bent met uw huidige haalbaarheid. Neem gerust contact op als u advies nodig
        heeft.
        <button v-if="!read.sent" @click="sendMessage(read);read=null">
          Versturen
        </button>
      </div>
    </modalWindow>

    <modalWindow v-if="sendAll" @close="sendAll=false">
      <div class="titlebar">Verstuur geselecteerd</div>
      <div class="inset">
        U gaat de volgende berichten versturen:
        <template v-for="check in checked">
          <p v-if="!messages[check].sent" :key="check">
            Melding haalbaarheid portefeuille ${{messages[check].port}} voor
            {{messages[check].email}}.
          </p>
        </template>
        <button @click="sendSelected">Versturen</button>
      </div>
    </modalWindow>

    <div class="card" v-if="messages !== null">
      <div class="msg" v-if="Object.keys(messages).length == 0">
        <awesomeIcon icon="exclamation-circle" /> U heeft nog geen berichten.
      </div>
      <template v-else>
        <table width=100%>
          <thead class="table-legend">
            <tr>
              <th>
                <button
                  v-if="checked.length != messages.length"
                  @click="checkAll"
                  class="secondary"
                  style="float:left;padding:0;"
                >
                  <awesomeIcon icon="fa-regular fa-square"/>
                </button>
                <button
                  v-else
                  @click="checked = []"
                  class="secondary"
                  style="float:left;padding:0;"
                >
                  <awesomeIcon icon="check-square"/>
                </button>
              </th>
              <th>Bericht</th>
              <th>Port</th>
              <th>E-mail</th>
              <th>Vandaag verstuurd</th>
              <th></th>
            </tr>
          </thead>
          <tr
            v-for="message in slice(
              filter(messages, searchFilter),
              currentPage * resultsPerPage,
              (currentPage + 1) * resultsPerPage)
            "
            :key="message.id"
          >
            <td v-if="!message.sent">
              <button
                v-if="checked.indexOf(message.id) === -1"
                @click="checked.push(message.id)"
                class="secondary"
                style="float:left;padding:0;"
              >
                <awesomeIcon icon="fa-regular fa-square"/>
              </button>
              <button
                v-else
                class="secondary"
                @click="checked.splice(checked.indexOf(message.id), 1)"
                style="float:left;padding:0;"
              >
                <awesomeIcon icon="check-square"/>
              </button>
            </td><td v-else></td>
            <td>
              Melding haalbaarheid {{formatPrice(Number(message.score), false, 1)}}%
              (alert {{message.alert}}%)
            </td>
            <td>{{message.port}}</td>
            <td>{{message.email}}</td>
            <td v-if="message.sent">Ja</td>
            <td v-else>Nee</td>
            <td>
              <button class="secondary" @click="read=message">
                <awesomeIcon icon="search-plus"/> Bekijk
              </button>
              <button class="secondary" v-if="!message.sent" @click="sendMessage(message)">
                <awesomeIcon icon="paper-plane"/> Versturen
              </button>
            </td>
          </tr>
        </table>
        <pagerElement
          v-model="currentPage"
          :records="filter(messages, searchFilter).length"
          :resultsPerPage="resultsPerPage"
        />
      </template>
    </div>
    <div v-else class="loader" />
  </div>
</template>

<script>
import { slice, filter } from 'lodash-es';

export default {
  name: 'AdminNotifications',
  data() {
    return {
      search: '',
      sendAll: false,
      read: null,
      messages: null,
      checked: [],
      currentPage: 0,
      resultsPerPage: 20,
      style: process.env.VUE_APP_STYLE,
    };
  },
  created() {
    this.getMessages();
  },
  methods: {
    slice,
    filter,
    updateSearch() {
      this.currentPage = 0;
      this.search = this.$refs.search.value.toLowerCase();
    },
    sendSelected() {
      this.sendAll = false;
      for (let i = 0; i < this.checked.length; i += 1) {
        this.sendMessage(this.messages[this.checked[i]]);
      }
    },
    checkAll() {
      this.checked = [];
      for (let i = 0; i < this.messages.length; i += 1) {
        this.checked.push(this.messages[i].id);
      }
    },
    dashboard() {
      this.$store.state.currentView = 'Dashboard';
    },
    getMessages() {
      this.checked = [];
      this.sdk.getAdminScoreMessages((response) => {
        if (response.status === 200) {
          for (let i = 0; i < response.data.length; i += 1) {
            response.data[i].id = i;
          }
          this.messages = response.data;
        } else {
          this.sdk.logout();
          window.location.reload();
        }
      });
    },
    sendMessage(message) {
      if (!message.sent) {
        this.messages[message.id].sent = true;
        this.sdk.createMessage(
          `${message.client}`,
          `De alertwaarde van portefeuille ${message.port} is bereikt`,
          `
            De haalbaarheid van uw doel ${message.name} is onder de door u opgegeven Alertwaarde van ${message.alert}% gekomen.<br><br>
            ${message.name ? `Uw doel: ${message.name}<br>` : ''}
            Uw portefeuille: ${message.port}<br>
            Uw alertwaarde: ${this.formatPrice(Number(message.alert), false, 1)}%<br>
            Uw huidige haalbaarheid: ${this.formatPrice(Number(message.score), false, 1)}%<br><br>
            U kunt uw haalbaarheid weer naar uw oorspronkelijke waarde verhogen of u kunt aangeven dat u tevreden bent met uw huidige haalbaarheid. Neem gerust contact op als u advies nodig heeft.
          `,
          `${message.port}`,
          1,
          this.getMessages,
          'Doelbeleggen',
        );
      }
    },
    searchFilter(obj) {
      const trimmedSearch = this.search.trim();
      if (obj.port.indexOf(trimmedSearch) > -1) {
        return true;
      }
      if (obj.email.indexOf(trimmedSearch) > -1) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
  tr {
    td {
      position: relative;
      .txt {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 600px;
        display: inline-block;
      }
    }
  }
  .secondary {
    padding: 0 10px;
    float: right;
  }
  .menubar {
    border-radius: 0;
    border-top-left-radius: $br;
    border-top-right-radius: $br;
    overflow: hidden;
  }
</style>
